module.exports = __webpack_public_path__ + "static/media/email_content.d864025b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/email_content.svg
// module id = 2706
// module chunks = 0